/* Stylesheet */

.insights_page_wrapper {
  display: flex;
  height: 100%;
  width: 100%;

  .insights_menu_container {
    position: static;
    z-index: 200;
  }
}
